import { memo } from 'react';
import { NodeProps, Handle, Position } from 'reactflow';

export const StopNode = memo((props: NodeProps) => {
  return (
    <div
      className="relative bg-white dark:bg-gray-800/90 border border-gray-200 dark:border-gray-600 rounded-xl shadow-sm hover:shadow-md transition-all duration-200 min-w-[180px] group cursor-pointer"
      style={{
        borderLeftWidth: 4,
        borderLeftColor: '#64748b',
      }}
    >
      {/* Botão de deletar */}
      {props.data.onDelete && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            props.data.onDelete();
          }}
          className="absolute -top-1.5 -right-1.5 w-6 h-6 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center hover:bg-red-600 z-10 shadow-md"
          title="Deletar node"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}

      {/* Handle de entrada apenas */}
      <Handle
        type="target"
        position={Position.Top}
        className="w-3 h-3 !bg-gray-300 dark:!bg-gray-500 !border-2 !border-white dark:!border-gray-700 !shadow-sm"
      />

      <div className="px-4 py-2.5">
        <div className="flex items-center gap-2">
          <span className="text-sm">🛑</span>
          <span className="font-semibold text-sm text-gray-900 dark:text-white">Stop</span>
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Finaliza o fluxo</p>
      </div>

      {/* Sem handle de saída */}
    </div>
  );
});

StopNode.displayName = 'StopNode';
